var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 63.806",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10 -20.76)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "5px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63 23.26-29.74 10.62h-10.38a10.38 10.38 0 0 0 0 20.76h2.12v23.46a4.17 4.17 0 0 0 8.33 0v-23.44l29.67 10.61z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.95,
    x2: 87.5,
    y1: 45.06,
    y2: 45.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.95,
    x2: 86.31,
    y1: 32.37,
    y2: 27.03
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.31,
    x2: 74.95,
    y1: 63.08,
    y2: 57.75
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24.97 54.64 33.3 54.66 33.26 33.88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNew);
export default __webpack_public_path__ + "static/media/whats-new.5b5649c0.svg";
export { ForwardRef as ReactComponent };